import React from 'react';
import { ILexiconCategory } from 'src/services';
import { SkeletonDefaultContent } from 'src/components-dummy/Skeleton/skeletonCompositions';
import { MainProductTagsListStyled } from './DeepTagProductTags.style';
import { DeepTagProductTag } from './DeepTagProductTag';
import {
  DeepTagForm,
  OnGeneratedAttributeEdit,
  OnRemoveOrRestoreTag,
} from '../../../DeepTagsProductForm.types';

export interface DeepTagProductTagsListProps {
  tagsFormData: DeepTagForm[];
  onRemoveTag: OnRemoveOrRestoreTag;
  lexiconCategoryAttributes?: ILexiconCategory['attributes'];
  onAttributeValueChange: ({
    valueKey,
    attributeKey,
  }: {
    valueKey: string;
    attributeKey: string;
  }) => void;
  tagToRemove: Partial<DeepTagForm> | undefined;
  shouldHideEditIndication: boolean;
  onGeneratedAttributeEdit?: OnGeneratedAttributeEdit;
}

export const DeepTagMainProductTagsList = ({
  tagsFormData,
  onAttributeValueChange,
  onRemoveTag,
  onGeneratedAttributeEdit,
  lexiconCategoryAttributes,
  tagToRemove,
  shouldHideEditIndication,
}: DeepTagProductTagsListProps): JSX.Element => {
  return (
    <MainProductTagsListStyled>
      {tagsFormData ? (
        <>
          {/* Tags form list */}
          {tagsFormData.map(
            ({ attribute, value, status, source, hasAddedInForm }: DeepTagForm): JSX.Element => {
              return (
                <DeepTagProductTag
                  key={attribute.key}
                  attribute={attribute}
                  value={value}
                  tagSource={source}
                  status={status}
                  tagToRemove={tagToRemove}
                  onRemoveTag={onRemoveTag}
                  hasAddedInForm={!!hasAddedInForm}
                  onAttributeValueChange={onAttributeValueChange}
                  onGeneratedAttributeEdit={onGeneratedAttributeEdit}
                  lexiconAttributeValues={lexiconCategoryAttributes?.[attribute.key]?.values}
                  shouldHideEditIndication={shouldHideEditIndication}
                />
              );
            }
          )}
        </>
      ) : (
        <SkeletonDefaultContent />
      )}
    </MainProductTagsListStyled>
  );
};
